import { MutationTree } from 'vuex';
import { ClockInState, ClockIn, Stamp } from '@/store/clockIn/types';
import _ from 'lodash';

const mutations: MutationTree<ClockInState> = {
  fetchedClockIns: (state, clockIn: ClockIn[]) => {
    state.clockIns = clockIn;
  },

  fetchedStamps: (state, stamps: Stamp[]) => {
    state.stamps = stamps;
  },
};

export default mutations;
